import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const Actions = styled.div`
  display: flex;
  flex-direction: ${props => props.direction};
  gap: ${props => props.theme.spacing.sp16};
`
